var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWarningIcon = function SvgWarningIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.168 1.407a1.333 1.333 0 0 0-2.336 0L.625 12.691a1.334 1.334 0 0 0 1.17 1.976h12.412a1.333 1.333 0 0 0 1.168-1.976L9.168 1.407ZM8 2.05l6.207 11.283H1.793L8 2.05Zm0 3.283A.667.667 0 0 1 8.667 6v3.333a.667.667 0 0 1-1.334 0V6A.667.667 0 0 1 8 5.333Zm.833 6.5a.833.833 0 1 1-1.667 0 .833.833 0 0 1 1.667 0Z",
    fill: "#515151"
  })));
};
export default SvgWarningIcon;